import { queryMode, queryTask } from "../../utils/querying/gis-data";
import * as geometryEngine from "@arcgis/core/geometry/geometryEngine";
export async function isIntersectGeometry(options) {
    let isValid = await validateGeomtry(options);
    return isValid === 0 ? false : true;
}
export function isContainsGeometry(settings) {
    return geometryEngine.contains(settings.containerGeometry, settings.insideGeometry);
}
function validateGeomtry(options) {
    return queryTask({
        url: options.url,
        where: options.where,
        mode: queryMode.FeatureCount,
        geometry: options.geometry,
        returnGeometry: false,
    });
}
